import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Row, Col, Card, Container, Dropdown, Tooltip, OverlayTrigger, Form, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import { useSelector, useDispatch } from "react-redux";
import { ReportsAction, SuperAdminAction, ValidationPassagepassActions } from "../../Actions";
import { saveAs } from "file-saver";
import CustomContentAlert, { tableHeightScrollBars, findBySearch, scroolToTop} from "../helper";
import moment from "moment";
import { getAPIResponse } from "../../Selectors/APIResponseReducer";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../Loader/Loader";
import DeleteResidentModal from "../Modal/DeleteResidentModal";
import Select from 'react-select';

function Rates() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const location_id = queryParams.get("location_id");
  const lot_id = queryParams.get("lot_id");
  const { property_id, timezone, property } = useSelector((userState) => userState.UserProfileDetails);
  const passagepassRateList = useSelector((state) => state.ReportsDetails.passagepassRateList);
  const ratebufferData = useSelector((state) => state.ReportsDetails.ratebufferData);
  const parkingLocation = useSelector((state) => state.ReportsDetails.parkingLocationList);
  const { lots } = useSelector((propertyState) => propertyState.SuperAdminDetails);
  const [allRates, setAllRates] = useState([]);          // preload cache (all lots)
  const [visibleRates, setVisibleRates] = useState([]);
  const [searchRateListData, setSearchRateListData] = useState([]);
  const [tableHeight, setTableHeight] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [findMore, setFindMore] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [rateDeleteModel, setRateDeleteModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showErrAlert, setShowErrAlert] = useState(false);
  const apiResponse = useSelector(getAPIResponse);
  //These states are used for copy modal
  const [copyModal, setCopyModal] = useState(false);
  const [copySourceLot, setCopySourceLot] = useState('');
  const [copySourceRate, setCopySourceRate] = useState('');
  const [copyTargetLots, setCopyTargetLots] = useState([]);
  const [conflictErrorMessage, setConflictErrorMessage] = useState("");
  const [conflictLoading, setConflictLoading] = useState(false);
  const [noRatesForLot, setNoRatesForLot] = useState(false);
  const ZERO_DATETIME = '0000-00-00 00:00:00'
  // const [isDeleteUpdate, setIsdeleteUpdate] = useState(false);
  const [state, setState] = useState({
    lot_ids: [],
    location_id: "",
    loader: false,
  });

  const customStyles = {
    rows: {
      style: {
        minHeight: "72px",          // base height for single-line rows
        whiteSpace: "normal",       // allow wrapping
        wordBreak: "break-word",    // break long words
        lineHeight: "1.4",          // improve readability
        alignItems: "center",
      },
    },
   headCells: {
  style: {
    paddingLeft: "6px",
    paddingRight: "6px",
    fontSize: "12px",          
    fontWeight: "600",       // keep headers readable
    lineHeight: "1.3",       // tighter line spacing
    whiteSpace: "normal",    // allow wrapping for long headers 
    textAlign: "center",     // optional: center align for compact headers
  },
},
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        paddingTop: "12px",   // add top padding
        paddingBottom: "10px", // add bottom padding
      },
    },
  };
  const refetchRates = useCallback(async () => {
    if (!property_id) return;

    const lotIdsForFetch = state.lot_ids?.length ? state.lot_ids : (lots || []).map(l => String(l.id));
    if (!lotIdsForFetch.length) return;

    setState(prev => ({ ...prev, loader: true }));

    await dispatch(ReportsAction.GetPassagePassRate({
      property_id,
      lot_ids: lotIdsForFetch,
      location_id: ""
    }));

    // passagepassRateList effect will update allRates; now re-apply filter immediately using latest lot_ids
    const selectedSet = new Set((state.lot_ids || []).map(String));
    const filtered = (passagepassRateList?.data || allRates || []).filter(r =>
      r.lot_id && selectedSet.has(String(r.lot_id))
    );

    setVisibleRates(filtered);
    setSearchRateListData([]);
    setSearchValue("");

    setState(prev => ({ ...prev, loader: false }));
  }, [dispatch, property_id, state.lot_ids, lots, passagepassRateList?.data, allRates]);

  const handleDelete = (row) => {
    setRateDeleteModel(true);
    setDeleteId(row?.id);
  };

  const handleDeleteRate = async () => {
    if (!deleteId) return;
    await dispatch(ReportsAction.DeletePassagePassRate(deleteId));
    await refetchRates();
    setRateDeleteModel(false);
    setDeleteId(null);
  };
  const handleCopyCreate = async () => {
    if (!copySourceRate || copyTargetLots.length === 0) {
      setConflictErrorMessage("At least one source rate and target lot is required.");
    setShowErrAlert(false);
    setTimeout(() => setShowErrAlert(true), 0);
    await refetchRates();
    return;
  }

  setCopyModal(false);

  const sourceRate = allRates.find(r => r.id === parseInt(copySourceRate, 10));
  if (!sourceRate) {
    setConflictErrorMessage("Source rate not found.");
    setShowErrAlert(false);
    setTimeout(() => setShowErrAlert(true), 0);
    return;
  }

  const isHolidayRate = !sourceRate.day || sourceRate.day.trim() === "";
  const days = isHolidayRate ? [] : sourceRate.day.split(",").map(d => d.trim());

  for (const targetLotId of copyTargetLots) {  // Sequential for...of for proper awaits
    const conflictPayload = {
      lot_ids: [targetLotId],
      ...(isHolidayRate && {
        effective_start: sourceRate.formatted_effective_start || ZERO_DATETIME,
        effective_stop: sourceRate.formatted_effective_stop || ZERO_DATETIME,
        rate_category: "holiday"
      }),
      ...(days.length && {
        days: days.join(","),
        rate_category: "regular"
      }),
      ignoreid: sourceRate.id
    };

    console.log("Checking conflicts for lot ID:", targetLotId, conflictPayload);
    
    const result = await dispatch(ValidationPassagepassActions.checkRateConflicts(conflictPayload));
    console.log("Direct API result:", result);  // {success:1, conflict:true, message:"Conflict detected..."}
    
    if (result?.conflict) {  // Safe ?. + now result is resolved object
      console.log("Conflict detected → blocking:", targetLotId, result);
      const targetLotName = lots?.find(lot => String(lot.id) === targetLotId)?.alias ||
        lots?.find(lot => String(lot.id) === targetLotId)?.name ||
        targetLotId;

      setConflictErrorMessage(
        `Cannot copy to "${targetLotName}": ${result.message}`
      );
      setShowErrAlert(false);
      setTimeout(() => setShowErrAlert(true), 0);
      continue;  // Skip bad lot
    }
    console.log("No conflict → creating rate for:", targetLotId);

    // Clean display_name before copy
    const cleanRateData = {
      ...sourceRate,
      display_name: sourceRate.display_name
        ?.replace(/\s*\(Copy to [^\)]*\)/gi, '')
        ?.replace(/\s*\(copy [^\)]*\)/gi, '')
        ?.trim() || sourceRate.display_name || 'Copied Rate'
    };

    await dispatch(ReportsAction.CreatePassagePassRate({
      ...cleanRateData,
      lot_ids: [targetLotId],
    }));
  }

  // Reset + refresh
  setCopySourceLot('');
  setCopySourceRate('');
  setCopyTargetLots([]);
  await handleSearch();
};

  // Function to format grace period from minutes to "X hr Y min"
  const formatGracePeriod = (mins) => {
    let formatted = "0 mins";

    if (mins && mins !== undefined && mins !== null && mins !== "" && !isNaN(mins)) {
      const numMins = Math.floor(Number(mins));
      if (numMins > 0) {
        const hours = Math.floor(numMins / 60);
        const remainingMins = numMins % 60;
        if (hours > 0) {
          formatted = `${hours} hr`;
          if (remainingMins > 0) {
            formatted += ` ${remainingMins} min`;
          }
        } else {
          formatted = `${numMins} mins`;
        }
      }
    }

    return formatted;
  };

  // const handleActive = (e, row) => {
  //   dispatch(
  //     ReportsAction.createGateScheduler({
  //       type: "updateActive",
  //       active: e.target?.checked,
  //       group_id: row?.group_id,
  //       property_id: property_id,
  //     }),
  //   );
  //   // setTimeout(() => {
  //   //   dispatch(GateSchedulerActions.clearAddUpdateDeleteRes());
  //   // }, 2500);
  // };

  const actionButton = (row) => {
    return (
      <Dropdown disabled={!state.location_id && !state.lot_ids} className="position-static">
        <Dropdown.Toggle variant="Primary" className="btn-xs" id="dropdown-basic">
          Action
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() =>
              history.push({
                pathname: "/edit-parking-rate",
                state: { ...row, lot_ids: state.lot_ids }, // pass all selected lots
              })
            }
          >
            Edit Rate
          </Dropdown.Item>
          <Dropdown.Item onClick={() => handleDelete(row)}>Delete Rate</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };
  const showFields = (name) => {
    return (
        <OverlayTrigger delay={{ show: 250, hide: 400 }} placement={"top"} overlay={<Tooltip id={`tooltip-qw`}>{name}</Tooltip>}>
          <div className="text-nowrap text-truncate">{name}</div>
        </OverlayTrigger>
    );
  };
  const showTimeField = (value) => {
  if (!value) return "-";

  // Handle pure time-only strings (HH:mm:ss or HH:mm)
  if (/^\d{2}:\d{2}(:\d{2})?$/.test(value)) {
    const parsed = moment(value, ["HH:mm:ss", "HH:mm"], true);
    if (!parsed.isValid()) return "-";

    const exact = parsed.format("HH:mm:ss"); // stored value
    const label = parsed.format("h:mm A");   // local readable, e.g., 6:15 PM

    return (
      <OverlayTrigger
        delay={{ show: 250, hide: 400 }}
        placement="top"
        overlay={<Tooltip id={`tooltip-${exact}`}>{exact}</Tooltip>}
      >
        <div className="text-nowrap text-truncate pr-2">{label}</div>
      </OverlayTrigger>
    );
  }

  // Handle full datetime values
  const parsed = moment(value, ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"], true);
  if (!parsed.isValid()) {
    console.warn("Invalid datetime:", value);
    return "-";
  }

  const exact = parsed.format("YYYY-MM-DD HH:mm:ss"); // exact backend format
  const label = parsed.local().format("MMM D, YYYY h:mm A"); // e.g., Nov 12, 2025 6:00 PM

  return (
    <OverlayTrigger
      delay={{ show: 250, hide: 400 }}
      placement="top"
      overlay={<Tooltip id={`tooltip-${exact}`}>{exact}</Tooltip>}
    >
        <div className="text-nowrap text-truncate pr-2">{label}</div>
      </OverlayTrigger>
    );
  };

  const getLotLabel = (row) =>
    String(
      row.lot_name ??
      row.lot_alias ??
      row.location_name ??
      row.location_alias ??
      row.lot_id ??
      row.location_id ??
      ""
    ).trim().toLowerCase();

  const getRateLabel = (row) =>
    String(row.display_name ?? row.rate_description ?? row.id ?? "").trim().toLowerCase();
  const getDayPriority = (row) => {
    if (!row.day?.trim()) return 7; // No day = last
    const days = row.day.trim().split(',').map(d => d.trim());
    const sundayIndex = days.findIndex(d => d === '0');
    return sundayIndex >= 0 ? 0 : 1; // 0=has Sunday (top), 1=others
  };

  const columns = useMemo(() => [
    {
      name: "Lot",
      sortable: true,
      cell: (row) => showFields(row.lot_alias || row.lot_name || row.lot_id || row.location_id),
      selector: (row) => row.lot_alias || row.lot_name || row.lot_id || row.location_id,

      // force clustering by lot
      sortFunction: (a, b) => {
        const lotCmp = getLotLabel(a).localeCompare(getLotLabel(b));
        if (lotCmp !== 0) return lotCmp;

        // 2. NEW: Sunday rates first within lot (0 top)
        const dayCmp = getDayPriority(a) - getDayPriority(b);
        if (dayCmp !== 0) return dayCmp;

        // 3. Rate name
        const rateCmp = getRateLabel(a).localeCompare(getRateLabel(b));
        if (rateCmp !== 0) return rateCmp;

        // 4. Newest ID first
        return Number(b.id ?? 0) - Number(a.id ?? 0);
      },
    },
    {
      name: "Title",
      sortable: true,
      cell: (row) => showFields(row.display_name),
      selector: (row) => row.display_name,
    },
    {
      name: "Event/Holiday",
      sortable: true,
      width: "140px", // optional: helps consistent alignment
      cell: (row) => {
        // Determine if this is a Holiday/Event rate: no specific days selected
        const isHolidayRate = !row.day ||
          row.day.trim() === "" ||
          row.day.trim() === "-" ||
          (row.day.trim().split(",")
            .filter(d => d.trim() !== "" && !isNaN(d.trim()))
            .length === 0);

        const displayText = isHolidayRate ? "Yes" : "No";

        return showFields(displayText);
      },
      selector: (row) => {
        const isHolidayRate = !row.day ||
          row.day.trim() === "" ||
          row.day.trim() === "-" ||
          (row.day.trim().split(",")
            .filter(d => d.trim() !== "" && !isNaN(d.trim()))
            .length === 0);

        return isHolidayRate ? "Yes" : "No";
      },
      sortFunction: (a, b) => {
        const getIsHoliday = (row) => {
          return !row.day ||
            row.day.trim() === "" ||
            row.day.trim() === "-" ||
            (row.day.trim().split(",")
              .filter(d => d.trim() !== "" && !isNaN(d.trim()))
              .length === 0);
        };

        const aHoliday = getIsHoliday(a);
        const bHoliday = getIsHoliday(b);

        if (aHoliday && !bHoliday) return -1;
        if (!aHoliday && bHoliday) return 1;
        return 0;
      },
    },
  {
    name: "Description",
    sortable: true,
    cell: (row) => showFields(row.rate_description),
    selector: (row) => row.rate_description,
  },
  {
    name: "Amount",
    sortable: true,
    cell: (row) => showFields("$"+row.max_amount),
    selector: (row) => row.max_amount,
  },
  {
    name: "Active Start",
    sortable: true,
    cell: (row) => showTimeField(row.entry_window_start),
    selector: (row) => row.entry_window_start,
  },
  {
    name: "Active Stop",
    sortable: true,
    cell: (row) => showTimeField(row.entry_window_stop),
    selector: (row) => row.entry_window_stop,
  },
 {
  name: "Day(s) of Week",
  sortable: true,
  width: "200px",
  cell: (row) => {
    if (row.day && row.day.trim()) {
      const days = row.day
        .trim()
        .split(",")
        .map((d) => d.trim())
        .filter((d) => d !== "" && !isNaN(d))
        .map(Number)
        .filter((d) => d >= 0 && d <= 6);
      const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      const dayNames = days.map((day) => weekdays[day]).join(", ");

      return (
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 400 }}
          overlay={<Tooltip id={`tooltip-days-${row.id}`}>{dayNames}</Tooltip>}
        >
          <div
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,          // max 2 lines
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              lineHeight: "1.4",
              maxHeight: "2.8em",          // 2 lines * line-height
              whiteSpace: "normal",
              cursor: "pointer",
            }}
          >
            {dayNames || "-"}
          </div>
        </OverlayTrigger>
      );
    }
    return <div>-</div>;
  },
  selector: (row) => (row.day && row.day.trim() ? row.day.trim() : "-"),
},
  {
    name: "Start Date",
    sortable: true,
    cell: (row) => {
      if (row.formatted_effective_start && row.formatted_effective_start !== ZERO_DATETIME) {
        const dateOnly = moment(row.formatted_effective_start).format("YYYY-MM-DD");
        return showFields(dateOnly);
      }
      return showFields("-");
    },
    selector: (row) => (row.formatted_effective_start ? row.formatted_effective_start : "-"),
  },
  {
    name: "Stop Date",
    sortable: true,
    cell: (row) => {
      if (row.formatted_effective_stop && row.formatted_effective_stop !== ZERO_DATETIME) {
        const dateOnly = moment(row.formatted_effective_stop).format("YYYY-MM-DD");
        return showFields(dateOnly);
      }
      return showFields("-");
    },
    selector: (row) => (row.formatted_effective_stop ? row.formatted_effective_stop : "-"),
  },
   {
    name: "Grace Period",
    sortable: true,
    cell: (row) => 
      {if(row.initial_grace_period_mins){
        return showFields(formatGracePeriod(row.initial_grace_period_mins));
      } 
      else return showFields("0")
    },  
    selector: (row) => row.initial_grace_period_mins || "0",
  },
  {
    name: "Action",
    cell: actionButton,
  },
], []);
const expandedComponent = ({ data }) => {
  // Helper to format grace period
  const formatGracePeriod = (mins) => {
    if (!mins || mins <= 0) return "-";
    const hours = Math.floor(mins / 60);
    const remainingMins = mins % 60;
    return hours > 0
      ? `${hours} hr${remainingMins > 0 ? ` ${remainingMins} min` : ""}`
      : `${remainingMins} mins`;
  };

  // Helper for session expires
  const formatExpiration = (expires) => {
    if (!expires) return "-";

    if (expires.includes("P")) {
      const match = expires.match(/P(\d+)DT(\d+)H(\d+)M/);
      if (match) {
        const days = match[1] ? `${match[1]} day${match[1] > 1 ? "s" : ""}` : "";
        const hours = match[2] ? `${match[2]} hour${match[2] > 1 ? "s" : ""}` : "";
        const mins = match[3] ? `${match[3]} minute${match[3] > 1 ? "s" : ""}` : "";
        return [days, hours, mins].filter(Boolean).join(" ") || "-";
      }
    }

    const parts = expires.split("DT");
    const dayMap = ["Same Day", "+1 Day", "+2 Days", "+3 Days", "+4 Days", "+5 Days", "+6 Days", "+7 Days"];
    const dayLabel = dayMap[parts[0]] || "Same Day";
    if (parts[1]) {
      const time = moment(parts[1], "HH:mm:ss").format("h:mm A");
      return `${dayLabel} at ${time}`;
    }
    return expires;
  };

  // Full days of week
  const fullDays = data.day && data.day.trim()
    ? data.day
        .trim()
        .split(",")
        .map(d => d.trim())
        .filter(d => !isNaN(d))
        .map(Number)
        .filter(d => d >= 0 && d <= 6)
        .map(d => ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][d])
        .join(", ")
    : "-";

  // Rate Type: Holiday or Regular
  const rateTypeDisplay = fullDays === "-" ? "Holiday" : "Regular";

  // renderRow with wider label column (no wrapping)
  const renderRow = (label, value, tooltip = false) => {
    const displayValue = value || "-";

    return (
      <Col md={4} lg={4} xs={12} className="mb-2">
        <Row className="no-gutters">
          <Col xs={5} className="pr-0">
            <b>{label}:</b>
          </Col>
          <Col xs={7}>
            {tooltip ? (
              <OverlayTrigger
                delay={{ show: 250, hide: 400 }}
                placement="top"
                overlay={<Tooltip id={`tooltip-${label.replace(/\s+/g, "-")}`}>{displayValue}</Tooltip>}
              >
                <span className="text-break">{displayValue}</span>
              </OverlayTrigger>
            ) : (
              <span>{displayValue}</span>
            )}
          </Col>
        </Row>
      </Col>
    );
  };

  return (
    <div className="extend-row">
      <Row className="expandedView mb-1 px-3">

        {/* Row 2 */}
        {renderRow("Initial Grace Period", formatGracePeriod(data.initial_grace_period_mins))}
        {renderRow("Subsequent Grace Period", formatGracePeriod(data.subsequent_grace_period_mins || data.initial_grace_period_mins))}
        {renderRow("Session Valid Until", formatExpiration(data.rate_expires), true)}
        {/* Row 5 - Incremental Pricing */}
        {data.incremental_cost && data.incremental_duration ? (
          <>
            {renderRow("Incremental Cost", `$${data.incremental_cost}`)}
            {renderRow("Incremental Duration", formatGracePeriod(data.incremental_duration))}
          </>
        ) : (
          renderRow("Incremental Fee", "No")
        )}
      </Row>
    </div>
  );
};
  const dataTableHandle = (data) => {
    return (
      <DataTable
        data={searchValue?.length ? searchRateListData : visibleRates}
        columns={columns}
        defaultSortFieldId={1}
        customStyles={customStyles}
        expandableRows
        expandableRowsComponent={expandedComponent}
        expandOnRowClicked
        highlightOnHover
        responsive={true}
        defaultSortAsc={true}
        fixedHeader={true}
        onChangePage={scroolToTop}
        fixedHeaderScrollHeight={tableHeight}
        pagination={true}
        paginationPerPage={100}
        paginationTotalRows={visibleRates?.length}
        paginationRowsPerPageOptions={[100, 200, 300, 400]}
        scrollable={true}
      />
    );
  };

  const handleSearchChange = async ({ target }) => {
    setSearchValue(target?.value);
    const columnList = ["display_name", "rate_description", "max_amount"];
    if (target.value.length) {
      if (!findMore) {
        setSearchRateListData(findBySearch(target.value, visibleRates, visibleRates, columnList, timezone));
      }
    }
  };

  useEffect(() => {
    console.log("Toast trigger:", { apiResponse, conflictErrorMessage });
    setShowAlert(!!apiResponse?.api_success_message);
    setShowErrAlert(!!conflictErrorMessage || !!apiResponse?.api_error_message);

    const timeout = setTimeout(() => {
      setShowAlert(false);
      setShowErrAlert(false);
      setConflictErrorMessage("");
    }, 5000);  // Match AddRateForm 5s

    return () => clearTimeout(timeout);
  }, [apiResponse?.api_success_message, apiResponse?.api_error_message, conflictErrorMessage]);

  useEffect(() => {
    if (!property_id) return;

    // Step 1: Fetch lots if needed (SuperAdminAction handles this)
    dispatch(SuperAdminAction.get_all_lots(property_id, "", false, true));

    // Step 2: Set up page
    const height = tableHeightScrollBars();
    dispatch(SuperAdminAction.setDomainHeader(property?.property_name, property?.domain));
    setTableHeight(height);
    setFindMore(false);
  }, [property_id, property?.property_name, property?.domain, dispatch]);

  // Fetch rates when lots become available
  useEffect(() => {
    if (!property_id || !lots?.length) return;

    let cancelled = false;

    const fetchRates = async () => {
      setState(prev => ({ ...prev, loader: true }));

      const allLotIds = lots.map(l => String(l.id));

      await dispatch(ReportsAction.GetPassagePassRate({
        property_id,
        lot_ids: allLotIds,
        location_id: ""
      }));

      if (!cancelled) {
        setState(prev => ({ ...prev, loader: false }));
      }
    };

    fetchRates();

    return () => {
      cancelled = true;
    };
  }, [property_id, lots, dispatch]);  //runs once when lots load

  // Update allRates when API returns data
  useEffect(() => {
    if (!passagepassRateList?.data) return;

    const data = passagepassRateList.data;
    if (Array.isArray(data)) {
      setAllRates(data);
    }
  }, [passagepassRateList?.data]);

  const handleExport = async () => {
    try {
      const exportLotIds = (state?.lot_ids?.length ? state.lot_ids : [lot_id || location_id]).filter(Boolean);
      if (!exportLotIds.length) return;

      const buffer = await dispatch(
        ValidationPassagepassActions.ExportPassagePassRates(property_id, exportLotIds, location_id)
      );


      const fileName = `parking-rates-${moment().format('YYYYMMDD-HHmmss')}.xlsx`;
      saveAs(
        new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        fileName
      );
    } catch (e) {
      console.error('Export error', e);
    }
  };

  const handleSearch = useCallback(() => {
    if (!state.lot_ids?.length) {
      setVisibleRates([]);
      setSearchRateListData([]);
      setSearchValue("");
      return;
    }
    const selectedSet = new Set(state.lot_ids.map(String));
    const filtered = (allRates || []).filter((r) => {
      const matches = r.lot_id && selectedSet.has(String(r.lot_id));
      return matches;
    });
    setVisibleRates(filtered);
    setSearchRateListData([]);
    setSearchValue("");
  }, [allRates, state.lot_ids]);


  const handleReset = () => {
    // Clear dropdown immediately
    setState(prev => ({ ...prev, lot_ids: [] }));

    setTimeout(() => {
      setState({
        lot_ids: [],
        location_id: "",
        loader: false,
      });
      setVisibleRates([]);
      setAllRates(allRates);
      setSearchRateListData([]);
      setSearchValue("");
      history.push({ pathname: "/parking-rate", search: `` });
    }, 0);
  };

  useEffect(() => {
    if (apiResponse?.api_success_message) {
      refetchRates();
    }
  }, [apiResponse?.api_success_message, refetchRates]);

useEffect(() => {
  let isMounted = true;

  const fetchLocations = async () => {
    if (state.lot_ids.length > 0 && (!parkingLocation || parkingLocation.length === 0)) {
      try {
        await Promise.all(state.lot_ids.map(lotId => 
          dispatch(ReportsAction.GetAllParkingLocation(lotId))
        ));
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching locations:", error);
        }
      }
    }
  };

  fetchLocations();

  return () => {
    isMounted = false;
  };
}, [state.lot_ids, dispatch]);
  useEffect(() => {
    if (!copySourceLot) {
      setNoRatesForLot(false);
      setCopySourceRate('');
      return;
    }
    const filteredRates = (allRates || []).filter(r => {
      const rateLotId = r.lot_id ?? r.location_id;
      return String(rateLotId) === String(copySourceLot);
    });
    const hasRates = filteredRates.length > 0;
    setNoRatesForLot(!hasRates);

    if (hasRates && !copySourceRate) {
      setCopySourceRate(String(filteredRates[0].id));
    }
  }, [copySourceLot, allRates]);

  return (
    <div>
      <Container fluid className="manage-unit-list-page page-no-fliter">
        <Card className="mb-0">
          <Card.Body className="pos-rel-overflow-hide">
            <>
              <header>
                <div className="active-permit-header sm-flex-column sm-align-items-start">
                  <h5 className="mb-2 mb-md-0">Parking Rate</h5>
                  <div className="filter-button d-flex flex-wrap">
                    <div className="d-flex align-items-center search-mb-0">
                    </div>
                    {(visibleRates.length > 0 || searchRateListData.length > 0) && (
                      <div className="ml-2">
                        <span
                          onClick={handleExport}
                          className="btn-fill btn-sm btn btn-info btn-medium cursor-pointer"
                        >
                          Export
                        </span>
                      </div>
                    )}
                    <div className="buttons-dd">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="Primary"
                          id="dropdown-basic"
                          className="btn btn-sm border-0 bg-light  w-30px h-30px d-flex align-items-center justify-content-center ml-2"
                        >
                          <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            className="text-sm"
                            onClick={() =>
                              history.push({
                                pathname: "/add-parking-rate",
                                state: { lot_ids: state.lot_ids },
                              })
                            }
                          >
                            <span className="pl-2">Add Rate</span>
                          </Dropdown.Item>
                          {/* Copy Rate option */}
                          <Dropdown.Item
                            className="text-sm"
                            onClick={() => setCopyModal(true)}
                          >
                            <span className="pl-2">Copy Rate</span>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              </header>
            </>
            <>
              <Row className="align-items-end mt-0">
                <Col md="8">
                  <Form.Group controlId="lots-select">
                    <div className="d-flex align-items-center justify-content-between mb-1">
                      <Form.Label className="mb-0">
                        Lots<span className="asterisk">*</span>
                      </Form.Label>

                      <label className="fancy-checkbox mb-0">
                        <input
                          type="checkbox"
                          id="select-all-lots"
                          disabled={!lots?.length}
                          checked={!!lots?.length && state.lot_ids.length === lots.length}
                          ref={(el) => {
                            if (el) {
                              el.indeterminate =
                                state.lot_ids.length > 0 &&
                                state.lot_ids.length < (lots?.length || 0);
                            }
                          }}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const allIds = checked ? lots.map(l => String(l.id)) : [];

                            setState(prev => ({
                              ...prev,
                              lot_ids: allIds,
                              location_id: ""
                            }));
                          }}
                        />
                        <span>
                          <i></i>Select all
                        </span>
                      </label>
                    </div>

                    <Select
                      isMulti
                      name="lot_ids"
                      value={lots?.map(lot => ({
                        value: lot.id,
                        label: lot.alias || lot.name || lot.id
                      })).filter(opt => state.lot_ids.includes(String(opt.value)))}
                      options={lots?.map(lot => ({
                        value: lot.id,
                        label: lot.alias || lot.name || lot.id
                      }))}
                      onChange={selected => {
                        const selectedIds = selected ? selected.map(opt => String(opt.value)) : [];
                        setState(prev => ({
                          ...prev,
                          lot_ids: selectedIds,
                          location_id: ""
                        }));
                      }}
                      classNamePrefix="react-select"
                      placeholder="Select lot(s)..."
                      isClearable
                      closeMenuOnSelect={false}
                      blurInputOnSelect={false}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md="4" className="d-flex justify-content-end">
                  <Button
                    className="btn-fill btn-sm mb-3"
                    type="Submit"
                    variant="primary"
                    onClick={handleSearch}
                    disabled={!state.lot_ids.length}
                  >
                    Find
                  </Button>
                  <Button
                    className="btn-fill btn-sm mb-3 ml-2"
                    type="Submit"
                    variant="primary"
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </Col>
              </Row>
              {state.loader ? (
                <Loader />
              ) : (
                <>
                  {visibleRates && (
                    <>
                      <div className="citation-list-table">{dataTableHandle(visibleRates)}</div>
                    </>
                  )}
                </>
              )}
            </>
            {rateDeleteModel && (
              <DeleteResidentModal
                showBrowserModal={rateDeleteModel}
                onOpen={rateDeleteModel}
                handleSave={handleDeleteRate}
                closeModal={() => setRateDeleteModel(false)}
                handleCancel={() => setRateDeleteModel(false)}
                details={{
                  title: "Parking Rate",
                  message: "Are you sure you want to delete this parking rate?",
                }}
                //  isDeleteCarddisabled={isDeleteCard}
                loading={false}
              />
            )}
            {/* NEW: Copy Rate Modal */}
            {copyModal && (
              <>
                <div
                  className="modal-backdrop fade show"
                  style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1040 }}
                  onClick={() => setCopyModal(false)}
                />
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  style={{ zIndex: 1050, top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Copy Rate</h5>
                        <button
                          type="button"
                          className="close"
                          onClick={() => setCopyModal(false)}
                        >
                          <span>&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <Row>
                          <Col md={6}>
                            <Form.Label><strong>From Lot:</strong></Form.Label>
                            <Form.Control
                              as="select"
                              value={copySourceLot}
                              onChange={(e) => {
                                setCopySourceLot(e.target.value);
                                setCopySourceRate('');
                              }}
                            >
                              <option value="">Select source lot...</option>
                              {lots?.map(lot => (
                                <option key={lot.id} value={lot.id}>
                                  {lot.alias || lot.name || lot.id}
                                </option>
                              ))}
                            </Form.Control>
                          </Col>
                          <Col md={6}>
                            <Form.Label>
                              <strong>Rate:</strong>{' '}
                            </Form.Label>
                            <Form.Control
                              as="select"
                              value={copySourceRate}
                              onChange={(e) => setCopySourceRate(e.target.value)}
                              disabled={!copySourceLot || noRatesForLot}
                            >
                              {noRatesForLot ? (
                                <option>No rates configured for this lot</option>
                              ) : (
                                <>
                                  <option value="">Select lot first...</option>
                                    {allRates
                                      ?.filter(r => {
                                        const rateLotId = r.lot_id ?? r.location_id;
                                        return String(rateLotId) === String(copySourceLot);
                                      })
                                      .map(r => {
                                      let name = (r.display_name || r.rate_description || 'Unnamed Rate')
                                        .replace(/\s*\(Copy to [^\)]+\)/gi, '')
                                        .replace(/\s*\(copy [^\)]+\)/gi, '')
                                        .trim();
                                      return (
                                        <option key={r.id} value={r.id}>
                                          {name}
                                        </option>
                                      );
                                    })}
                                </>
                              )}
                            </Form.Control>
                          </Col>
                        </Row>
                        <Row className="mt-3">
                          <Col md={12}>
                            <Form.Label><strong>To Lot(s):</strong></Form.Label>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                              {lots?.map(lot => {
                                const isSourceLot = String(lot.id) === String(copySourceLot);
                                const disabledWhenNoRates = noRatesForLot;  // ← NEW
                                return (
                                  <label key={lot.id} className={`fancy-checkbox mt-2 ${isSourceLot || disabledWhenNoRates ? 'text-muted opacity-50' : ''}`}>
                                    <input
                                      type="checkbox"
                                      style={{
                                        opacity: (isSourceLot || disabledWhenNoRates) ? 0.5 : 1,
                                        backgroundColor: disabledWhenNoRates ? '#e9ecef' : (isSourceLot ? '#e9ecef' : 'inherit'),
                                        cursor: disabledWhenNoRates || isSourceLot ? 'not-allowed' : 'pointer'
                                      }}
                                      checked={copyTargetLots.includes(String(lot.id))}
                                      disabled={isSourceLot || disabledWhenNoRates}  // ← NEW
                                      onChange={(e) => {
                                        if (disabledWhenNoRates) return;  // ← Guard
                                        const id = String(lot.id);
                                        setCopyTargetLots(prev =>
                                          e.target.checked
                                            ? [...prev, id]
                                            : prev.filter(l => l !== id)
                                        );
                                      }}
                                    />
                                    <span style={{
                                      opacity: (isSourceLot || disabledWhenNoRates) ? 0.5 : 1,
                                      color: disabledWhenNoRates ? '#6c757d' : 'inherit'
                                    }}>
                                      <i></i>{lot.alias || lot.name || lot.id}
                                    </span>
                                  </label>
                                );
                              })}
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="modal-footer">
                        <Button variant="secondary" onClick={() => setCopyModal(false)}>
                          Cancel
                        </Button>
                        <Button
                          variant="primary"
                          onClick={handleCopyCreate}  // ← NEW handler
                          disabled={!copySourceRate || copyTargetLots.length === 0}
                        >
                          Copy
                        </Button>

                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

          </Card.Body>
        </Card>
        <>
          {showAlert && apiResponse?.api_success_message && (
            <CustomContentAlert delay={5000} message={apiResponse?.api_success_message} className="toast-success" />
          )}
          {showErrAlert && conflictErrorMessage && (
            <CustomContentAlert delay={5000} message={conflictErrorMessage} className="toast-error" />
          )}
          {showErrAlert && apiResponse?.api_error_message && (
            <CustomContentAlert delay={5000} message={apiResponse?.api_error_message} className="toast-error" />
          )}
        </>
      </Container>
    </div>
  );
}

export default Rates;
